/**
 * Etikettenformate für den Dymo LabelWriter.
 *
 * Maße in Millimetern, so wie Dymo sie für die jeweilige Rolle angibt.
 * `landscape` beschreibt, ob das Etikett quer bedruckt wird (Endlosrolle
 * läuft in Höhenrichtung durch den Drucker).
 */

export interface LabelFormat {
  id: string;
  /** Dymo-Artikelnummer */
  sku: string;
  label: string;
  widthMm: number;
  heightMm: number;
  landscape: boolean;
  /** Wie viel Platz neben dem QR-Code für Text bleibt — steuert das Layout. */
  textLines: 1 | 2 | 3;
}

export const LABEL_FORMATS = [
  {
    id: 'dymo-11354',
    sku: '11354',
    label: 'Dymo 11354 — 57 × 32 mm (Mehrzweck)',
    widthMm: 57,
    heightMm: 32,
    landscape: true,
    textLines: 3,
  },
  {
    id: 'dymo-11352',
    sku: '11352',
    label: 'Dymo 11352 — 54 × 25 mm (Rücksendeadresse)',
    widthMm: 54,
    heightMm: 25,
    landscape: true,
    textLines: 2,
  },
  {
    id: 'dymo-30336',
    sku: '30336',
    label: 'Dymo 30336 — 54 × 25 mm (klein, Mehrzweck)',
    widthMm: 54,
    heightMm: 25,
    landscape: true,
    textLines: 2,
  },
  {
    id: 'dymo-11355',
    sku: '11355',
    label: 'Dymo 11355 — 51 × 19 mm (schmal)',
    widthMm: 51,
    heightMm: 19,
    landscape: true,
    textLines: 1,
  },
  {
    id: 'dymo-99012',
    sku: '99012',
    label: 'Dymo 99012 — 89 × 36 mm (groß, Adresse)',
    widthMm: 89,
    heightMm: 36,
    landscape: true,
    textLines: 3,
  },
] as const satisfies readonly LabelFormat[];

export type LabelFormatId = (typeof LABEL_FORMATS)[number]['id'];

export const DEFAULT_LABEL_FORMAT: LabelFormatId = 'dymo-11354';

export function getLabelFormat(id: string): LabelFormat | undefined {
  return LABEL_FORMATS.find((f) => f.id === id);
}

/** Was der QR-Code enthält: der Tiefenlink auf die Detailseite. */
export function assetQrPayload(appUrl: string, assetId: number): string {
  return `${appUrl.replace(/\/+$/, '')}/assets/${assetId}`;
}
